// @ts-nocheck
import React, { useState, useEffect, useMemo } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, addDoc, deleteDoc, doc, updateDoc, serverTimestamp, getDocs, query, where, setDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, updatePassword, sendPasswordResetEmail } from 'firebase/auth';
import { Calendar, Clock, Plus, Trash2, LogOut, ChevronDown, ChevronLeft, ShieldCheck, Users, X, Loader2, Cpu, Upload, AlertCircle, Settings, CreditCard, Key, LayoutGrid, List, Sun, Moon, Search, Archive, ArrowUpDown } from 'lucide-react';

// --- DIRECTE FIREBASE CONFIGURATIE ---
const firebaseConfig = {
  apiKey: "AIzaSyADW4lijTjpUBImyB4ER_5auqhk_RqNWz0",
  authDomain: "atc-aduard.firebaseapp.com",
  projectId: "atc-aduard",
  storageBucket: "atc-aduard.firebasestorage.app",
  messagingSenderId: "940309538703",
  appId: "1:940309538703:web:7038a2e1531287cd9e0dfa"
};

const appId = 'atc-aduard-v3';

// --- INITIALISATIE ---
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

// Constanten
const BANEN = ['Baan 1', 'Baan 2', 'Baan 3'];
const START_UUR = 7;
const EIND_UUR = 22;

// --- STYLE INJECTOR ---
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (!document.getElementById('tailwind-cdn')) {
    const script = document.createElement('script');
    script.id = 'tailwind-cdn';
    script.src = "https://cdn.tailwindcss.com";
    document.head.appendChild(script);
  }
  if (!document.getElementById('dark-mode-styles')) {
    const style = document.createElement('style');
    style.id = 'dark-mode-styles';
    style.innerHTML = `
      html.dark, html.dark body { background-color: #151A22 !important; color: #F3F4F6 !important; }
      html.dark .bg-white { background-color: #222834 !important; border-color: #334155 !important; }
      html.dark .bg-slate-50 { background-color: #151A22 !important; }
      html.dark .bg-slate-50\\/80 { background-color: #1E2532 !important; border-color: #334155 !important; }
      html.dark thead, html.dark thead.bg-slate-50 { background-color: #1E2532 !important; }
      html.dark thead th { color: #D1D5DB !important; font-weight: 800 !important; }
      html.dark .bg-slate-100 { background-color: #151A22 !important; color: #F3F4F6 !important; }
      html.dark .text-slate-800, html.dark .text-slate-900, html.dark .text-slate-700 { color: #F3F4F6 !important; }
      html.dark .text-slate-600, html.dark .text-slate-500, html.dark .text-slate-400, html.dark .text-slate-300 { color: #9CA3AF !important; }
      html.dark .text-\\[\\#091E6D\\] { color: #4DA8DA !important; }
      html.dark .bg-\\[\\#091E6D\\] { background-color: #4DA8DA !important; color: #151A22 !important; }
      html.dark header.bg-\\[\\#091E6D\\] { background-color: #222834 !important; border-bottom: 1px solid #334155; }
      html.dark header.bg-\\[\\#091E6D\\] .text-white, html.dark header.bg-\\[\\#091E6D\\] button { color: #F3F4F6 !important; }
      html.dark .bg-\\[\\#F77C1A\\] { background-color: #E56B55 !important; color: #151A22 !important; }
      html.dark .text-\\[\\#F77C1A\\] { color: #E56B55 !important; }
      html.dark .border-\\[\\#F77C1A\\] { border-color: #E56B55 !important; }
      html.dark .border-slate-100, html.dark .border-slate-200 { border-color: #334155 !important; }
      html.dark td, html.dark th { border-color: #334155 !important; }
      html.dark .divide-slate-50 > :not([hidden]) ~ :not([hidden]), html.dark .divide-slate-100 > :not([hidden]) ~ :not([hidden]) { border-color: #334155 !important; }
      html.dark input, html.dark select, html.dark textarea { background-color: #151A22 !important; color: #4DA8DA !important; border-color: #334155 !important; }
      html.dark .bg-\\[\\#091E6D\\]\\/5 { background-color: rgba(77, 168, 218, 0.1) !important; border-color: rgba(77, 168, 218, 0.2) !important; }
      html.dark .bg-\\[\\#091E6D\\]\\/10 { background-color: #2A3645 !important; color: #4DA8DA !important; }
      html.dark .bg-\\[\\#F77C1A\\]\\/10 { background-color: rgba(229, 107, 85, 0.1) !important; }
      html.dark .hover\\:bg-slate-50:hover { background-color: #2A3645 !important; }
      html.dark .hover\\:bg-slate-50\\/50:hover { background-color: rgba(42, 54, 69, 0.5) !important; }
      html.dark .shadow-sm, html.dark .shadow-xl, html.dark .shadow-2xl { box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3) !important; }
      
      /* Trash icons red */
      html.dark .text-red-400, html.dark .text-red-500, html.dark .text-red-600 { color: #E56B55 !important; }
      html.dark .bg-red-50 { background-color: rgba(229, 107, 85, 0.1) !important; border-color: rgba(229, 107, 85, 0.2) !important; }
      html.dark .hover\\:bg-red-500\\/10:hover, html.dark .group-hover\\:bg-red-50:hover { background-color: rgba(229, 107, 85, 0.15) !important; }
      
      /* Consistent states on dark mode */
      html.dark .bg-amber-50 { background-color: rgba(245, 158, 11, 0.1) !important; }
      html.dark .bg-green-50 { background-color: rgba(16, 185, 129, 0.1) !important; }
      html.dark .border-green-100 { border-color: rgba(16, 185, 129, 0.2) !important; }
    `;
    document.head.appendChild(style);
  }
}

const checkIsNightTime = () => {
  const date = new Date();
  const month = date.getMonth();
  const hour = date.getHours() + date.getMinutes() / 60;
  
  const sunTimes = [
    { rise: 8.5, set: 16.5 },
    { rise: 7.5, set: 17.5 },
    { rise: 6.5, set: 18.5 },
    { rise: 6.5, set: 20.5 },
    { rise: 5.5, set: 21.5 },
    { rise: 5.2, set: 22.0 },
    { rise: 5.5, set: 22.0 },
    { rise: 6.0, set: 21.0 },
    { rise: 7.0, set: 20.0 },
    { rise: 8.0, set: 19.0 },
    { rise: 8.0, set: 16.5 },
    { rise: 8.5, set: 16.5 },
  ];
  
  const todayTimes = sunTimes[month];
  return hour < todayTimes.rise || hour >= todayTimes.set;
};

const App = () => {
  const [sessionUser, setSessionUser] = useState(null); 
  const [appUser, setAppUser] = useState(null); 
  const [reservations, setReservations] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [whitelist, setWhitelist] = useState([]); 
  const [appSettings, setAppSettings] = useState({});
  const [selectedDateStr, setSelectedDateStr] = useState(new Date().toISOString().split('T')[0]);
  const [view, setView] = useState('calendar'); 
  const [adminTab, setAdminTab] = useState('users');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [bookingViewMode, setBookingViewMode] = useState('blocks');
  const [bookingSortOrder, setBookingSortOrder] = useState('asc');
  
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      const sessionOverride = sessionStorage.getItem('atc_theme_override');
      if (sessionOverride) {
        return sessionOverride === 'dark';
      }
      return checkIsNightTime();
    }
    return false;
  });
  
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', new: '' });
  const [passwordStatus, setPasswordStatus] = useState({ loading: false, error: null, success: false });

  const [userToDelete, setUserToDelete] = useState(null); 
  const [whitelistItemToDelete, setWhitelistItemToDelete] = useState(null); 
  const [reservationToDelete, setReservationToDelete] = useState(null);
  const [paymentModal, setPaymentModal] = useState({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
  const [conflictModal, setConflictModal] = useState({ isOpen: false, conflicts: [] });
  
  // Auth Modes: 'login', 'activate', 'forgot-password'
  const [authMode, setAuthMode] = useState('login'); 
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(false); // Nieuw: Voor wachtwoord vergeten
  const [currentTime, setCurrentTime] = useState(new Date());

  const [adminSearchTerm, setAdminSearchTerm] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [importText, setImportText] = useState('');
  const [whitelistEmail, setWhitelistEmail] = useState('');
  
  const [formData, setFormData] = useState({ 
    startTime: '10:00', 
    endTime: '11:00', 
    duration: '60', 
    courts: [], 
    dates: [''],
    useBallMachine: false,
    description: '' 
  });

  useEffect(() => {
    let timer;
    if (paymentModal.clicked && paymentModal.countdown > 0 && !paymentModal.isRedirecting) {
      timer = setTimeout(() => {
        setPaymentModal(prev => ({ ...prev, countdown: prev.countdown - 1 }));
      }, 1000);
    } else if (paymentModal.clicked && paymentModal.countdown === 0 && !paymentModal.showCode && !paymentModal.isRedirecting) {
      const currentRes = reservations.find(r => r.id === paymentModal.reservationId);
      if (currentRes && currentRes.paymentStatus === 'paid') {
        setPaymentModal(prev => ({ ...prev, showCode: true }));
        localStorage.removeItem('pendingMolliePayment');
      } else {
        setPaymentModal(prev => ({ ...prev, countdown: 5 }));
      }
    }
    return () => clearTimeout(timer);
  }, [paymentModal.clicked, paymentModal.countdown, paymentModal.showCode, paymentModal.reservationId, paymentModal.isRedirecting, reservations]);

  useEffect(() => {
    const pendingId = localStorage.getItem('pendingMolliePayment');
    if (pendingId && reservations.length > 0 && !paymentModal.isOpen) {
      const res = reservations.find(r => r.id === pendingId);
      if (res) {
        if (res.paymentStatus === 'paid') {
          setPaymentModal({ isOpen: true, reservationId: pendingId, clicked: true, countdown: 0, showCode: true, isRedirecting: false });
          localStorage.removeItem('pendingMolliePayment');
        } else if (res.paymentStatus === 'pending') {
          setPaymentModal({ isOpen: true, reservationId: pendingId, clicked: true, countdown: 5, showCode: false, isRedirecting: false });
        } else {
          localStorage.removeItem('pendingMolliePayment');
        }
      }
    }
  }, [reservations, paymentModal.isOpen]);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('atc_theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('atc_theme', 'light');
    }
  }, [isDarkMode]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setSessionUser(firebaseUser);
      
      if (firebaseUser) {
        try {
          const userCol = collection(db, 'artifacts', appId, 'public', 'data', 'users');
          const q = query(userCol, where('email', '==', firebaseUser.email));
          const snap = await getDocs(q);
          
          if (!snap.empty) {
            const userData = { id: snap.docs[0].id, ...snap.docs[0].data() };
            setAppUser(userData);
            localStorage.setItem(`atc_user_${appId}`, JSON.stringify(userData));
          }
        } catch (err) {
          console.error("Fout bij ophalen gebruikergegevens:", err);
        }
      } else {
        setAppUser(null);
        localStorage.removeItem(`atc_user_${appId}`);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!sessionUser || !db) return;
    const resCol = collection(db, 'artifacts', appId, 'public', 'data', 'reservations');
    const unsubRes = onSnapshot(resCol, (snap) => {
      setReservations(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Firestore res error:", err));

    const userCol = collection(db, 'artifacts', appId, 'public', 'data', 'users');
    const unsubUsers = onSnapshot(userCol, (snap) => {
      setAllUsers(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Firestore users error:", err));

    const whitelistCol = collection(db, 'artifacts', appId, 'public', 'data', 'whitelist');
    const unsubWhitelist = onSnapshot(whitelistCol, (snap) => {
      setWhitelist(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Firestore whitelist error:", err));

    const settingsDoc = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');
    const unsubSettings = onSnapshot(settingsDoc, (snap) => {
      if (snap.exists()) {
        setAppSettings(snap.data());
      }
    }, (err) => console.error("Firestore settings error:", err));

    return () => { unsubRes(); unsubUsers(); unsubWhitelist(); unsubSettings(); };
  }, [sessionUser]);

  const timeToMinutes = (timeStr) => {
    if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return 0;
    const [h, m] = timeStr.split(':').map(Number);
    return (h * 60) + (m || 0);
  };

  const calculateDuration = (start, end) => {
    const diff = timeToMinutes(end) - timeToMinutes(start);
    return diff > 0 ? diff : 0;
  };

  const formatWeekdayLong = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string' || dateStr.split('-').length !== 3) return dateStr || "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    return dateObj.toLocaleDateString('nl-NL', { weekday: 'long' });
  };

  const formatDayMonth = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string' || dateStr.split('-').length !== 3) return dateStr || "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    return dateObj.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
  };

  const formatFullLongDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string' || dateStr.split('-').length !== 3) return dateStr || "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    return dateObj.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  const formatDateToNL = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string' || dateStr.split('-').length !== 3) return dateStr || "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    const days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    const d = dateObj.getDate().toString().padStart(2, '0');
    const m = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const y = dateObj.getFullYear();
    return `${days[dateObj.getDay()]} ${d}-${m}-${y}`;
  };

  const getDayOnly = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return "";
    const parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };
  
  const getEndTimeStr = (startTime, durationMins) => {
    const startMins = timeToMinutes(startTime);
    const endMins = startMins + parseInt(durationMins || 0, 10);
    const h = Math.floor(endMins / 60);
    const m = endMins % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
  };

  const getWeekGroup = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    
    const d = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1)/7);
    return `Week ${weekNo}, ${d.getUTCFullYear()}`;
  };

  const getMonthGroup = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return "";
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return dateStr;
    const month = dateObj.toLocaleDateString('nl-NL', { month: 'long' });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    return `${capitalizedMonth} ${dateObj.getFullYear()}`;
  };

  const timeSlots = useMemo(() => {
    const slots = [];
    for (let h = START_UUR; h <= EIND_UUR; h++) {
      slots.push(`${h.toString().padStart(2, '0')}:00`);
      slots.push(`${h.toString().padStart(2, '0')}:30`);
    }
    return slots;
  }, []);

  useEffect(() => {
    if (!loading && view === 'calendar' && timeSlots.length > 0) {
      const isToday = selectedDateStr === new Date().toISOString().split('T')[0];
      if (isToday) {
         const nowMins = new Date().getHours() * 60 + new Date().getMinutes();
         let targetSlot = timeSlots[0];
         for(let slot of timeSlots) {
           if (timeToMinutes(slot) + 30 >= nowMins) {
             targetSlot = slot;
             break;
           }
         }
         setTimeout(() => {
           const el = document.getElementById(`slot-${targetSlot}`);
           if (el) {
             el.scrollIntoView({ behavior: 'smooth', block: 'center' });
           }
         }, 300);
      }
    }
  }, [loading, view, selectedDateStr, timeSlots]);

  const dailyReservations = useMemo(() => {
    return reservations.filter((res) => res.date === selectedDateStr);
  }, [reservations, selectedDateStr]);

  const activeReservationsCount = useMemo(() => {
    if (!appUser) return 0;
    const today = new Date().toISOString().split('T')[0];
    return reservations.filter((res) => res.userEmail === appUser.email && res.date >= today).length;
  }, [reservations, appUser]);

  const myReservations = useMemo(() => {
    if (!appUser) return [];
    return reservations.filter((r) => r.userEmail === appUser.email);
  }, [reservations, appUser]);

  const todayStrFilter = useMemo(() => new Date().toISOString().split('T')[0], []);

  const upcomingReservations = useMemo(() => {
    return myReservations
      .filter(r => r.date >= todayStrFilter)
      .sort((a, b) => {
        const dateDiff = bookingSortOrder === 'desc' 
          ? b.date.localeCompare(a.date) 
          : a.date.localeCompare(b.date);
        if (dateDiff !== 0) return dateDiff;
        
        const timeDiff = bookingSortOrder === 'desc' 
          ? b.startTime.localeCompare(a.startTime) 
          : a.startTime.localeCompare(b.startTime);
        if (timeDiff !== 0) return timeDiff;
        
        return a.court.localeCompare(b.court);
      });
  }, [myReservations, todayStrFilter, bookingSortOrder]);

  const pastReservations = useMemo(() => {
    return myReservations
      .filter(r => r.date < todayStrFilter)
      .sort((a, b) => {
        const dateDiff = b.date.localeCompare(a.date);
        if (dateDiff !== 0) return dateDiff;
        const timeDiff = b.startTime.localeCompare(a.startTime);
        if (timeDiff !== 0) return timeDiff;
        return a.court.localeCompare(b.court);
      });
  }, [myReservations, todayStrFilter]);

  const groupedMyReservations = useMemo(() => {
    if (!appUser) return {};
    const isAdvancedUser = ['admin', 'vcl'].includes(appUser.role);
    return upcomingReservations.reduce((groups, res) => {
      const groupKey = isAdvancedUser ? getMonthGroup(res.date) : getWeekGroup(res.date);
      if (!groups[groupKey]) groups[groupKey] = [];
      groups[groupKey].push(res);
      return groups;
    }, {});
  }, [upcomingReservations, appUser]);

  const sortedGroupKeys = useMemo(() => {
    return Object.keys(groupedMyReservations).sort((a, b) => {
      const val = groupedMyReservations[b][0].date.localeCompare(groupedMyReservations[a][0].date);
      return bookingSortOrder === 'desc' ? val : -val;
    });
  }, [groupedMyReservations, bookingSortOrder]);

  const archiveGrouped = useMemo(() => {
    return pastReservations.reduce((groups, res) => {
      const groupKey = getMonthGroup(res.date);
      if (!groups[groupKey]) groups[groupKey] = [];
      groups[groupKey].push(res);
      return groups;
    }, {});
  }, [pastReservations]);

  const archiveGroupKeys = useMemo(() => {
    return Object.keys(archiveGrouped).sort((a, b) => {
      return archiveGrouped[b][0].date.localeCompare(archiveGrouped[a][0].date);
    });
  }, [archiveGrouped]);

  const profileReservations = useMemo(() => {
    if (!selectedUserProfile) return [];
    return reservations.filter((r) => r.userEmail === selectedUserProfile.email).sort((a, b) => {
      const dateDiff = b.date.localeCompare(a.date);
      if (dateDiff !== 0) return dateDiff;
      const timeDiff = b.startTime.localeCompare(a.startTime);
      if (timeDiff !== 0) return timeDiff;
      return a.court.localeCompare(b.court);
    });
  }, [reservations, selectedUserProfile]);

  const updateDateRow = (index, value) => {
    let newDates = [...(formData.dates || [])];
    newDates[index] = value;
    if (['admin', 'vcl'].includes(appUser?.role) && index === newDates.length - 1 && value !== '') {
      newDates.push('');
    }
    setFormData((prev) => ({ ...prev, dates: newDates }));
  };

  const getSevenDays = () => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date();
      d.setDate(d.getDate() + i);
      days.push(d.toISOString().split('T')[0]);
    }
    return days;
  };

  const checkOverlap = (startTime, duration, date, court, currentReservations) => {
    const start = timeToMinutes(startTime);
    const end = start + parseInt(duration || 0, 10);
    return currentReservations.some(res => {
      if (res.date !== date || res.court !== court) return false;
      const resStart = timeToMinutes(res.startTime);
      const resEnd = resStart + parseInt(res.duration || 0, 10);
      return (start < resEnd && end > resStart);
    });
  };

  const checkMachineOverlap = (startTime, duration, date, currentReservations) => {
    const start = timeToMinutes(startTime);
    const end = start + parseInt(duration || 0, 10);
    return currentReservations.some(res => {
      if (res.date !== date || !res.useBallMachine) return false;
      const resStart = timeToMinutes(res.startTime);
      const resEnd = resStart + parseInt(res.duration || 0, 10);
      return (start < resEnd && end > resStart);
    });
  };

  // Functie voor Wachtwoord Vergeten
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setResetSuccess(false);

    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail) {
      setError("Vul eerst je e-mailadres in.");
      return;
    }

    setSubmitting(true);
    try {
      await sendPasswordResetEmail(auth, cleanEmail);
      setResetSuccess(true);
    } catch (err) {
      console.error("Wachtwoord reset fout:", err);
      if (err.code === 'auth/user-not-found') {
        setError("Dit e-mailadres is niet bij ons bekend.");
      } else if (err.code === 'auth/invalid-email') {
        setError("Vul een geldig e-mailadres in.");
      } else {
        setError("Er is een fout opgetreden. Probeer het later opnieuw.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  // Login en Register handler
  const handleAuth = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setSubmitting(true);
    const cleanEmail = email.trim().toLowerCase();

    try {
      if (authMode === 'login') {
        await signInWithEmailAndPassword(auth, cleanEmail, password);
      } else if (authMode === 'activate') {
        const whitelistCol = collection(db, 'artifacts', appId, 'public', 'data', 'whitelist');
        const wQuery = query(whitelistCol, where('email', '==', cleanEmail));
        const wSnap = await getDocs(wQuery);
        
        if (wSnap.empty) {
          setError("E-mail staat niet op de ledenlijst. Vraag het bestuur.");
          setSubmitting(false);
          return;
        }

        const userCol = collection(db, 'artifacts', appId, 'public', 'data', 'users');
        const q = query(userCol, where('email', '==', cleanEmail));
        const snap = await getDocs(q);
        if (!snap.empty) {
          setError("Dit e-mailadres is al geactiveerd. Probeer in te loggen.");
          setSubmitting(false);
          return;
        }

        const userCredential = await createUserWithEmailAndPassword(auth, cleanEmail, password);
        const newUserData = {
          uid: userCredential.user.uid,
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          fullName: `${firstName.trim()} ${lastName.trim()}`,
          email: cleanEmail,
          role: 'member', 
          isApproved: true,
          createdAt: new Date().toISOString()
        };

        const docRef = await addDoc(userCol, newUserData);
        const finalUserData = { id: docRef.id, ...newUserData };
        setAppUser(finalUserData);
        localStorage.setItem(`atc_user_${appId}`, JSON.stringify(finalUserData));
      }
    } catch (err) { 
      const error = err;
      console.error(error);
      if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        setError("E-mailadres of wachtwoord is onjuist.");
      } else if (error.code === 'auth/user-not-found') {
        setError("Account niet gevonden. Klik op 'Activeren' om te registreren.");
      } else if (error.code === 'auth/email-already-in-use') {
        setError("Dit e-mailadres is al in gebruik. Probeer in te loggen.");
      } else if (error.code === 'auth/weak-password') {
        setError("Het wachtwoord is te zwak (minimaal 6 tekens vereist).");
      } else {
        setError("Er ging iets mis met authenticatie. Probeer het opnieuw.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (!auth.currentUser) return;
    
    if (passwordForm.new.length < 6) {
       setPasswordStatus({ loading: false, error: "Nieuw wachtwoord moet minimaal 6 tekens zijn.", success: false });
       return;
    }

    setPasswordStatus({ loading: true, error: null, success: false });
    
    try {
      await signInWithEmailAndPassword(auth, auth.currentUser.email, passwordForm.current);
      await updatePassword(auth.currentUser, passwordForm.new);
      setPasswordStatus({ loading: false, error: null, success: true });
      
      setTimeout(() => {
        setIsPasswordModalOpen(false);
        setPasswordForm({ current: '', new: '' });
        setPasswordStatus({ loading: false, error: null, success: false });
      }, 2000);

    } catch (err) {
      console.error(err);
      if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setPasswordStatus({ loading: false, error: "Het huidige wachtwoord is onjuist.", success: false });
      } else {
        setPasswordStatus({ loading: false, error: "Fout bij het wijzigen. Probeer het opnieuw.", success: false });
      }
    }
  };

  const handleBulkImport = async () => {
    if (!db || submitting) return;
    const emails = importText.split(/[,\n\s]+/).map((e) => e.trim().toLowerCase()).filter((e) => e.includes('@'));
    if (emails.length === 0) return alert("Geen e-mailadressen gevonden.");
    setSubmitting(true);
    try {
      const whitelistCol = collection(db, 'artifacts', appId, 'public', 'data', 'whitelist');
      const promises = emails.map(emailAddr => {
        if (!whitelist.some(item => item.email === emailAddr)) {
          return addDoc(whitelistCol, { email: emailAddr, addedAt: serverTimestamp(), invited: false });
        }
        return Promise.resolve();
      });
      await Promise.all(promises);
      setImportText('');
      setAdminTab('whitelist');
      alert("Ledenlijst bijgewerkt.");
    } catch (e) { alert("Import mislukt."); } finally { setSubmitting(false); }
  };

  const handleAddToWhitelist = async (e) => {
    if (e) e.preventDefault();
    if (!db || submitting) return;
    const cleanEmail = whitelistEmail.trim().toLowerCase();
    if (!cleanEmail) return;
    setSubmitting(true);
    try {
      await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'whitelist'), {
        email: cleanEmail, addedAt: serverTimestamp(), invited: false
      });
      setWhitelistEmail('');
    } catch (e) { console.error(e); } finally { setSubmitting(false); }
  };

  const updateUserRole = async (uid, newRole) => {
    if (!db) return;
    try {
      await updateDoc(doc(db, 'artifacts', appId, 'public', 'data', 'users', uid), { role: newRole });
    } catch(err) {
      console.error("Fout bij updaten rol:", err);
      alert("Er is een fout opgetreden bij het opslaan van de rol.");
    }
  };

  const handleSaveSettings = async (e) => {
    e.preventDefault();
    if (!db || submitting) return;
    setSubmitting(true);
    try {
      const newApiKey = e.target.mollieApiKey.value.trim();
      const updateData = {
        paymentLink: e.target.paymentLink.value.trim(),
        lockCode: e.target.lockCode.value.trim()
      };
      
      if (newApiKey && newApiKey !== 'xxxxxxxxxxxxxxxxxxxxxxxx') {
        updateData.mollieApiKey = newApiKey;
      }

      await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general'), updateData, { merge: true });
      alert("Instellingen succesvol opgeslagen!");
    } catch (err) {
      console.error(err);
      alert("Fout bij het opslaan van instellingen.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleBooking = async (e) => {
    e.preventDefault();
    if (!appUser || submitting || !db) return;
    
    const duration = ['admin', 'vcl'].includes(appUser.role) 
      ? calculateDuration(formData.startTime, formData.endTime) 
      : parseInt(formData.duration || '60', 10);

    if (duration <= 0) {
      setConflictModal({ isOpen: true, conflicts: ["Kies een geldige eindtijd die ná de starttijd ligt."] });
      return;
    }

    setSubmitting(true);
    try {
      const resCol = collection(db, 'artifacts', appId, 'public', 'data', 'reservations');
      const validDates = (formData.dates || []).filter((d) => d && d !== '');
      const conflicts = [];

      validDates.forEach((dateVal) => {
        (formData.courts || []).forEach((courtName) => {
          if (checkOverlap(formData.startTime, duration, dateVal, courtName, reservations)) {
            conflicts.push(`${courtName} op ${formatDayMonth(dateVal)}`);
          }
        });
        if (formData.useBallMachine && checkMachineOverlap(formData.startTime, duration, dateVal, reservations)) {
          conflicts.push(`Ballenmachine op ${formatDayMonth(dateVal)}`);
        }
      });

      if (conflicts.length > 0) {
        setConflictModal({ isOpen: true, conflicts });
        setSubmitting(false);
        return;
      }

      const safeFullName = appUser.fullName || 'Beheerder';
      const safeFirstName = appUser.firstName || safeFullName.split(' ')[0] || 'Beheerder';

      const promises = validDates.flatMap((dateVal) => 
        (formData.courts || []).map((courtName) => 
          addDoc(resCol, {
            name: String(safeFullName),
            firstName: String(safeFirstName),
            date: dateVal,
            startTime: formData.startTime,
            duration: duration,
            court: courtName,
            useBallMachine: formData.useBallMachine,
            description: ['admin', 'vcl'].includes(appUser.role) ? String(formData.description || '') : '', 
            paymentStatus: (formData.useBallMachine && !['admin', 'vcl'].includes(appUser.role)) ? 'pending' : 'paid',
            userEmail: appUser.email || '',
            isAdminBooking: ['admin', 'vcl'].includes(appUser.role),
            bookerRole: appUser.role,
            createdAt: serverTimestamp()
          })
        )
      );
      const docRefs = await Promise.all(promises);
      setIsModalOpen(false);
      
      if (formData.useBallMachine && !['admin', 'vcl'].includes(appUser.role)) {
        setPaymentModal({ isOpen: true, reservationId: docRefs[0]?.id, clicked: true, countdown: 0, showCode: false, isRedirecting: true });
        
        try {
          const mollieResponse = await fetch('/api/mollie', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              amount: "6.99",
              description: `Huur ballenmachine ${formatDateToNL(validDates[0])}`,
              orderId: docRefs[0]?.id,
              apiKey: appSettings.mollieApiKey
            })
          });
          
          const mollieData = await mollieResponse.json();
          if (mollieData.url) {
            localStorage.setItem('pendingMolliePayment', docRefs[0]?.id);
            window.location.href = mollieData.url; 
            return; 
          } else {
            setConflictModal({ isOpen: true, conflicts: ["Fout bij aanmaken betaallink: " + (mollieData.error || 'Onbekende fout')] });
            setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
          }
        } catch (err) {
          console.error("Mollie API Fout:", err);
          setConflictModal({ isOpen: true, conflicts: ["Kan geen verbinding maken met de betaalprovider."] });
          setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
        }
      }
      
    } catch (err) { 
      console.error(err);
      setConflictModal({ isOpen: true, conflicts: ["Opslaan mislukt door een serverfout."] }); 
    } finally { 
      setSubmitting(false); 
    }
  };

  const handlePayPending = async (r) => {
    setPaymentModal({ isOpen: true, reservationId: r.id, clicked: true, countdown: 0, showCode: false, isRedirecting: true });
    try {
      const mollieResponse = await fetch('/api/mollie', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: "6.99",
          description: `Huur ballenmachine ${formatDateToNL(r.date)}`,
          orderId: r.id,
          apiKey: appSettings.mollieApiKey
        })
      });
      const mollieData = await mollieResponse.json();
      if (mollieData.url) {
        localStorage.setItem('pendingMolliePayment', r.id);
        window.location.href = mollieData.url;
      } else {
        setConflictModal({ isOpen: true, conflicts: ["Fout bij aanmaken betaallink: " + (mollieData.error || 'Onbekende fout')] });
        setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
      }
    } catch (err) {
      console.error("Mollie API Fout:", err);
      setConflictModal({ isOpen: true, conflicts: ["Kan geen verbinding maken met de betaalprovider."] });
      setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
    }
  };

  const toggleCourtSelection = (court) => {
    const duration = ['admin', 'vcl'].includes(appUser.role) ? calculateDuration(formData.startTime, formData.endTime) : parseInt(formData.duration || '60', 10);
    const isBusy = (formData.dates || []).filter((d) => d && d !== '').some((date) => checkOverlap(formData.startTime, duration, date, court, reservations));
    
    if (isBusy) return;

    setFormData((prev) => {
      const prevCourts = prev.courts || [];
      if (!['admin', 'vcl'].includes(appUser.role)) {
        return { ...prev, courts: [court] };
      }
      const exists = prevCourts.includes(court);
      if (exists) {
        return { ...prev, courts: prevCourts.filter((c) => c !== court) };
      } else {
        return { ...prev, courts: [...prevCourts, court] };
      }
    });
  };

  const approveUser = (uid) => {
    if (!db) return;
    updateDoc(doc(db, 'artifacts', appId, 'public', 'data', 'users', uid), { isApproved: true });
  };

  const confirmDeleteUser = async () => {
    if (!userToDelete || !db) return;
    try {
      await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'users', userToDelete.id));
      setUserToDelete(null);
    } catch(err) {
      console.error("Fout bij verwijderen:", err);
    }
  };

  const confirmDeleteWhitelistItem = async () => {
    if (!whitelistItemToDelete || !db) return;
    try {
      await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'whitelist', whitelistItemToDelete.id));
      setWhitelistItemToDelete(null);
    } catch(err) {
      console.error("Fout bij verwijderen:", err);
    }
  };

  const confirmDeleteReservation = async () => {
    if (!reservationToDelete || !db) return;
    try {
      await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'reservations', reservationToDelete.id));
      setReservationToDelete(null);
    } catch(err) {
      console.error("Fout bij verwijderen reservering:", err);
    }
  };

  const logout = async () => { 
    try {
      await signOut(auth);
    } catch(err) {
      console.error("Fout bij uitloggen:", err);
    }
    setAppUser(null);
    localStorage.removeItem(`atc_user_${appId}`);
    setIsDropdownOpen(false); 
    setView('calendar');
  };

  if (loading) return <div className="h-screen flex items-center justify-center bg-slate-50"><Loader2 className="animate-spin text-[#091E6D]" size={40} /></div>;

  if (!appUser) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#091E6D] via-[#05113D] to-black text-slate-800 text-center">
        <div className="bg-white w-full max-w-md rounded-[40px] shadow-2xl p-10 overflow-hidden relative text-center">
          <div className="text-center mb-10 text-slate-800">
            <img src="/logo.png" alt="ATC Logo" className="mx-auto mb-4 h-16 w-auto object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextElementSibling.style.display = 'block'; }} />
            <ShieldCheck className="text-[#F77C1A] mx-auto mb-4 hidden" size={40} />
            <h1 className="text-2xl font-black italic tracking-tighter uppercase leading-none text-slate-800 text-center">ATC ADUARD</h1>
            <p className="text-slate-400 text-[10px] font-bold tracking-widest uppercase mt-1 text-center">Reserveringssysteem</p>
          </div>
          
          {authMode === 'forgot-password' ? (
            // --- WACHTWOORD VERGETEN FORMULIER ---
            <form onSubmit={handlePasswordReset} className="space-y-4 text-left text-slate-800">
              <p className="text-sm font-bold text-slate-500 mb-6 text-center">
                Vul je e-mailadres in. Je ontvangt een Firebase link om veilig een nieuw wachtwoord in te stellen.
              </p>
              
              {resetSuccess && (
                <div className="p-4 bg-green-50 text-green-600 text-xs font-bold rounded-2xl text-center mb-4 border border-green-100">
                  Er is een e-mail verstuurd naar {email}. Check je inbox (en spamfolder) om je wachtwoord te resetten.
                </div>
              )}
              
              {!resetSuccess && (
                <>
                  <input type="email" required placeholder="E-mailadres" className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-slate-800 text-sm focus:border-[#F77C1A] outline-none transition-all" value={email} onChange={e => setEmail(e.target.value)} />
                  {error && <div className="p-4 bg-red-50 text-red-600 text-xs font-bold rounded-2xl text-center">{error}</div>}
                  <button type="submit" disabled={submitting} className="w-full py-5 bg-[#F77C1A] hover:bg-[#e06b12] text-white rounded-2xl font-black uppercase text-xs flex items-center justify-center gap-2 transition-all">
                    {submitting ? <Loader2 className="animate-spin text-white" size={18} /> : 'Reset Link Sturen'}
                  </button>
                </>
              )}
              
              <button type="button" onClick={() => { setAuthMode('login'); setResetSuccess(false); setError(null); }} className="w-full mt-4 text-slate-400 text-[10px] font-black uppercase tracking-widest hover:text-[#091E6D] transition-all text-center">
                 Terug naar inloggen
              </button>
            </form>
          ) : (
            // --- REGULIER INLOGGEN / ACTIVEREN FORMULIER ---
            <>
              <div className="flex bg-slate-100 p-1 rounded-2xl mb-6 text-slate-800">
                <button type="button" onClick={() => { setAuthMode('login'); setError(null); }} className={`flex-1 py-2 rounded-xl text-xs font-black transition-all ${authMode === 'login' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>INLOGGEN</button>
                <button type="button" onClick={() => { setAuthMode('activate'); setError(null); }} className={`flex-1 py-2 rounded-xl text-xs font-black transition-all ${authMode === 'activate' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>ACTIVEREN</button>
              </div>
              <form onSubmit={handleAuth} className="space-y-4 text-left text-slate-800">
                {authMode === 'activate' && (
                  <div className="grid grid-cols-2 gap-3 text-slate-800">
                    <input required placeholder="Voornaam" className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-sm text-slate-800 focus:border-[#F77C1A] outline-none transition-all" value={firstName} onChange={e => setFirstName(e.target.value)} />
                    <input required placeholder="Achternaam" className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-sm text-slate-800 focus:border-[#F77C1A] outline-none transition-all" value={lastName} onChange={e => setLastName(e.target.value)} />
                  </div>
                )}
                <input type="email" required placeholder="E-mailadres" className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-slate-800 text-sm focus:border-[#F77C1A] outline-none transition-all" value={email} onChange={e => setEmail(e.target.value)} />
                <input type="password" required minLength={6} placeholder="Wachtwoord (min. 6 tekens)" className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-slate-800 text-sm focus:border-[#F77C1A] outline-none transition-all" value={password} onChange={e => setPassword(e.target.value)} />
                
                {authMode === 'login' && (
                  <div className="text-right mt-2 mb-2">
                    <button type="button" onClick={() => { setAuthMode('forgot-password'); setError(null); setResetSuccess(false); }} className="text-xs font-bold text-slate-400 hover:text-[#F77C1A] transition-all">
                      Wachtwoord vergeten?
                    </button>
                  </div>
                )}

                {error && <div className="p-4 bg-red-50 text-red-600 text-xs font-bold rounded-2xl text-center">{error}</div>}
                
                <button type="submit" disabled={submitting} className="w-full py-5 bg-[#F77C1A] hover:bg-[#e06b12] text-white rounded-2xl font-black uppercase text-xs flex items-center justify-center gap-2 transition-all">
                  {submitting ? <Loader2 className="animate-spin text-white" size={18} /> : (authMode === 'login' ? 'Inloggen' : 'Account Activeren')}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 pb-20 font-sans text-left">
      <header className="bg-[#091E6D] text-white sticky top-0 z-40 shadow-xl">
        <div className="max-w-5xl mx-auto px-4 py-5 flex justify-between items-center text-white text-center relative z-50">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => setView('calendar')}>
            <h1 className="text-xl font-black italic tracking-tighter uppercase leading-none text-white">ATC ADUARD</h1>
          </div>
          
          <nav className="hidden md:flex items-center gap-4 bg-white/10 p-1 rounded-2xl text-white">
            <button onClick={() => setView('calendar')} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-[10px] font-black transition-all ${view === 'calendar' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-white/70 hover:text-white'}`}>
              <Calendar size={14} /> AGENDA
            </button>
            <button onClick={() => setView('my-bookings')} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-[10px] font-black transition-all ${view === 'my-bookings' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-white/70 hover:text-white'}`}>
              <Clock size={14} /> MIJN BOEKINGEN
            </button>
            {appUser.role === 'admin' && (
              <button onClick={() => { setView('admin-users'); setAdminTab('users'); setAdminSearchTerm(''); }} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-[10px] font-black transition-all ${view === 'admin-users' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-white/70 hover:text-white'}`}>
                <ShieldCheck size={14} /> BEHEER
              </button>
            )}
          </nav>

          <div className="relative text-left text-white flex items-center gap-3">
            <button type="button" onClick={() => {
              const newMode = !isDarkMode;
              setIsDarkMode(newMode);
              if (typeof window !== 'undefined') {
                sessionStorage.setItem('atc_theme_override', newMode ? 'dark' : 'light');
              }
            }} className="p-2.5 bg-white/10 hover:bg-white/20 rounded-xl text-white transition-all" title="Wissel thema">
              {isDarkMode ? <Sun size={16} /> : <Moon size={16} />}
            </button>
            
            <div className="relative">
              <button type="button" onClick={() => setIsDropdownOpen(!isDropdownOpen)} className={`flex items-center gap-3 px-4 py-2 rounded-2xl border bg-white/10 border-white/10 text-white`}>
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center font-black text-xs uppercase text-white">{appUser.firstName?.charAt(0) || appUser.fullName?.charAt(0)}</div>
                <p className="text-xs font-black hidden sm:block uppercase tracking-tighter text-white">{appUser.firstName || appUser.fullName}</p>
                <ChevronDown size={14} className={isDropdownOpen ? 'rotate-180 text-white' : 'text-white'} />
              </button>
              {isDropdownOpen && (
                <div className="absolute right-0 mt-3 w-64 bg-white rounded-3xl shadow-2xl border border-slate-100 overflow-hidden text-slate-700 animate-in fade-in slide-in-from-top-2 z-50">
                  <div className="p-5 border-b border-slate-50 text-left text-slate-700">
                     <p className="font-black text-sm text-slate-800">
                       {appUser.fullName}
                       {appUser.role === 'vcl' && <span className="ml-2 bg-[#F77C1A] text-white text-[8px] px-2 py-0.5 rounded-md uppercase tracking-wider">VCL</span>}
                     </p>
                     <p className="text-[10px] text-slate-400 font-bold uppercase truncate">{appUser.email}</p>
                  </div>
                  <div className="p-2 text-left md:hidden text-slate-700">
                    <button type="button" onClick={() => { setView('calendar'); setIsDropdownOpen(false); }} className="w-full px-5 py-4 text-left text-sm font-bold hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors text-[#091E6D]">
                      <Calendar size={18} /> Agenda
                    </button>
                    <button type="button" onClick={() => { setView('my-bookings'); setIsDropdownOpen(false); }} className="w-full px-5 py-4 text-left text-sm font-bold hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors text-slate-700">
                      <Clock size={18} /> Mijn Boekingen
                    </button>
                    {appUser.role === 'admin' && (
                      <button type="button" onClick={() => { setView('admin-users'); setAdminTab('users'); setAdminSearchTerm(''); setIsDropdownOpen(false); }} className="w-full px-5 py-4 text-left text-sm font-bold hover:bg-slate-50 rounded-xl flex items-center gap-3 text-[#F77C1A] transition-colors">
                        <Users size={18} /> Leden Beheer
                      </button>
                    )}
                    <div className="h-px bg-slate-100 my-2"></div>
                  </div>
                  <div className="p-2 text-left text-slate-700">
                    <button type="button" onClick={() => { setIsPasswordModalOpen(true); setIsDropdownOpen(false); }} className="w-full px-5 py-4 text-left text-sm font-bold hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors text-slate-700">
                      <Key size={18} /> Wachtwoord wijzigen
                    </button>
                    <button type="button" onClick={logout} className="w-full px-5 py-4 text-left text-sm font-bold hover:bg-red-50 rounded-xl text-red-500 flex items-center gap-3 transition-colors">
                      <LogOut size={18} /> Uitloggen
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {view === 'calendar' && (
          <div className="bg-white/5 border-t border-white/5 overflow-x-auto scroll-smooth">
            <div className="max-w-5xl mx-auto flex text-white">
              {getSevenDays().map(date => (
                <button type="button" key={date} onClick={() => setSelectedDateStr(date)} className={`flex-1 min-w-[110px] py-4 flex flex-col items-center relative transition-all ${selectedDateStr === date ? 'text-white' : 'text-white/50 hover:text-white'}`}>
                  <span className="text-[10px] font-black uppercase mb-1 text-white">{formatWeekdayLong(date)}</span>
                  <span className="text-sm font-black italic text-white">{formatDayMonth(date)}</span>
                  {selectedDateStr === date && <div className="absolute bottom-0 left-0 right-0 h-1 bg-white rounded-t-full shadow-[0_-4px_10px_white]"></div>}
                </button>
              ))}
            </div>
          </div>
        )}
      </header>

      <main className="max-w-5xl mx-auto px-4 py-8 text-left text-slate-800">
        {view === 'calendar' && (
          <div className="bg-white rounded-[40px] shadow-sm border border-slate-200 overflow-hidden text-center text-slate-800 text-left">
             <div className="bg-slate-50/80 p-6 border-b border-slate-200 flex justify-between items-center text-slate-800 backdrop-blur-sm">
                <h2 className="text-xl font-black italic tracking-tighter uppercase text-left text-[#091E6D]">
                   <span className="hidden sm:inline">AGENDA </span>
                   {formatFullLongDate(selectedDateStr)}
                </h2>
                <div className="flex items-center gap-2 text-[10px] font-black text-slate-400 uppercase tracking-tighter"><Cpu size={14} className="text-[#F77C1A]" /> Ballenmachine beschikbaar</div>
             </div>
             <div className="divide-y divide-slate-100 text-slate-800 text-left">
                {timeSlots.map(time => {
                  const nowMinutes = timeToMinutes(time);
                  
                  const isToday = selectedDateStr === currentTime.toISOString().split('T')[0];
                  const currentMins = currentTime.getHours() * 60 + currentTime.getMinutes();
                  const isCurrentSlot = isToday && currentMins >= nowMinutes && currentMins < (nowMinutes + 30);
                  const linePercent = isCurrentSlot ? ((currentMins - nowMinutes) / 30) * 100 : 0;

                  const slotOccupants = dailyReservations.filter((r) => {
                    const start = timeToMinutes(r.startTime);
                    const end = start + parseInt(r.duration || '60', 10);
                    return nowMinutes >= start && nowMinutes < end;
                  });
                  const avail = BANEN.filter(baan => !slotOccupants.some((occ) => occ.court === baan));
                  return (
                    <div key={time} id={`slot-${time}`} className="flex min-h-[85px] group text-left text-slate-800 relative">
                      
                      {isCurrentSlot && (
                        <div className="absolute left-0 right-0 h-0.5 bg-[#F77C1A] z-20 pointer-events-none flex items-center" style={{ top: `${linePercent}%` }}>
                          <div className="w-24 flex justify-end pr-2">
                            <div className="w-2 h-2 rounded-full bg-[#F77C1A]"></div>
                          </div>
                        </div>
                      )}

                      <div className="w-24 border-r border-slate-100 p-6 flex items-start justify-center text-sm font-black text-slate-400 tracking-tighter relative z-10">{time}</div>
                      <div className="flex-1 p-3 space-y-2 text-left relative z-10">
                        {slotOccupants.map((r) => (
                          <div key={r.id} className="bg-white border border-slate-200 rounded-2xl p-4 flex justify-between items-center shadow-sm">
                            <div className="flex items-center gap-4 text-left">
                              <span className="bg-[#091E6D] text-white text-[10px] px-3 py-1 rounded-full font-black uppercase tracking-widest">{r.court}</span>
                              <div className="flex items-center gap-2 text-slate-800 text-left">
                                <div className="flex flex-col text-left">
                                  <p className="text-slate-800 text-sm text-left">
                                    {r.isAdminBooking ? (r.description ? <span><span className="font-black text-[#091E6D]">{r.bookerRole === 'vcl' ? 'VCL' : 'Beheerder'}</span> {typeof r.description === 'string' ? r.description : ''}</span> : <span className="font-black text-[#091E6D]">{r.bookerRole === 'vcl' ? 'VCL' : 'Beheerder'}</span>) : <span className="font-black text-slate-800">{typeof r.firstName === 'string' ? r.firstName : 'Lid'}</span>}
                                  </p>
                                  <span className="text-xs font-bold text-slate-400">{r.startTime} - {getEndTimeStr(r.startTime, r.duration)}</span>
                                </div>
                                {r.useBallMachine && (
                                  <span className="flex items-center gap-1 text-[10px] font-bold text-[#F77C1A] bg-[#F77C1A]/10 px-2 py-0.5 rounded-md">
                                    <Cpu size={12} />
                                    {r.paymentStatus === 'pending' && 'Te Betalen'}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              {appUser.role === 'admin' && r.useBallMachine && r.paymentStatus === 'pending' && (
                                <button type="button" onClick={() => updateDoc(doc(db, 'artifacts', appId, 'public', 'data', 'reservations', r.id), { paymentStatus: 'paid' })} className="text-amber-500 hover:text-green-500 transition-all p-2 bg-amber-50 rounded-full" title="Markeer als betaald">
                                  <CreditCard size={14} />
                                </button>
                              )}
                              {(r.userEmail === appUser.email || appUser.role === 'admin') && <button type="button" onClick={() => setReservationToDelete(r)} className="text-red-400 hover:text-red-500 hover:bg-red-500/10 p-1.5 rounded-lg transition-all"><Trash2 size={18} /></button>}
                            </div>
                          </div>
                        ))}
                        {avail.length > 0 ? (
                          <button type="button" disabled={!appUser.isApproved && !['admin', 'vcl'].includes(appUser.role)} onClick={() => { 
                            const firstAvail = avail[0]; 
                            const timeIdx = timeSlots.indexOf(time);
                            const defaultEndTime = timeSlots[timeIdx + 2] || timeSlots[timeSlots.length - 1];
                            setFormData((prev) => ({ 
                              ...prev, 
                              startTime: time || '10:00', 
                              endTime: defaultEndTime || '11:00', 
                              duration: '60', 
                              courts: firstAvail ? [firstAvail] : [], 
                              dates: ['admin', 'vcl'].includes(appUser.role) ? [selectedDateStr || '', ''] : [selectedDateStr || ''], 
                              useBallMachine: false, 
                              description: '' 
                            })); 
                            setIsModalOpen(true); 
                          }} className="w-full min-h-[50px] border-2 border-dashed border-slate-200 rounded-2xl text-slate-400 font-black text-[10px] uppercase tracking-widest hover:border-[#F77C1A]/50 hover:text-[#F77C1A] hover:bg-[#F77C1A]/10 flex items-center justify-center gap-2 disabled:opacity-20 transition-all"><Plus size={16} /> RESERVEER ({avail.length} VRIJ)</button>
                        ) : slotOccupants.length === 0 ? <div className="p-4 text-center text-[10px] text-slate-300 font-black uppercase tracking-widest italic">Niet beschikbaar</div> : null}
                      </div>
                    </div>
                  );
                })}
             </div>
          </div>
        )}

        {view === 'my-bookings' && (
          <div className="space-y-6 animate-in slide-in-from-bottom-4 text-left text-slate-800">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-2 text-slate-800 text-left">
              <div className="flex items-center gap-3">
                <Clock className="text-[#091E6D]" size={28} />
                <h2 className="text-3xl font-black italic tracking-tighter uppercase text-[#091E6D] text-left">Mijn Boekingen</h2>
              </div>
              <div className="flex bg-slate-100 p-1 rounded-2xl text-slate-800 self-start sm:self-auto overflow-x-auto items-center">
                <button type="button" onClick={() => setBookingSortOrder(prev => prev === 'desc' ? 'asc' : 'desc')} className={`px-4 py-2 rounded-xl text-[10px] flex items-center gap-2 font-black uppercase transition-all text-slate-500 hover:bg-white hover:text-[#091E6D] hover:shadow-sm whitespace-nowrap`}>
                  <ArrowUpDown size={14} /> {bookingSortOrder === 'desc' ? 'Nieuwste Eerst' : 'Oudste Eerst'}
                </button>
                <div className="w-px h-6 bg-slate-200 mx-1"></div>
                <button type="button" onClick={() => setView('archive')} className={`px-4 py-2 rounded-xl text-[10px] flex items-center gap-2 font-black uppercase transition-all text-slate-500 hover:text-slate-700 mr-2 whitespace-nowrap`}><Archive size={14} /> Archief</button>
                <button type="button" onClick={() => setBookingViewMode('blocks')} className={`px-4 py-2 rounded-xl text-[10px] flex items-center gap-2 font-black uppercase transition-all whitespace-nowrap ${bookingViewMode === 'blocks' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}><LayoutGrid size={14} /> Blokken</button>
                <button type="button" onClick={() => setBookingViewMode('list')} className={`px-4 py-2 rounded-xl text-[10px] flex items-center gap-2 font-black uppercase transition-all whitespace-nowrap ${bookingViewMode === 'list' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}><List size={14} /> Lijst</button>
              </div>
            </div>

            {upcomingReservations.length === 0 ? (
              <div className="col-span-full py-20 text-center bg-white rounded-[40px] border-2 border-dashed border-slate-200 text-slate-800 text-center">
                <Clock className="mx-auto text-slate-300 mb-4" size={48} />
                <p className="text-slate-400 font-black uppercase text-xs tracking-widest">Je hebt nog geen aankomende boekingen gepland.</p>
              </div>
            ) : bookingViewMode === 'list' ? (
              <div className="bg-white rounded-[32px] border border-slate-100 shadow-sm overflow-hidden text-left text-slate-800 animate-in fade-in duration-300">
                <div className="overflow-x-auto">
                  <table className="w-full text-slate-800 text-left whitespace-nowrap">
                    <thead className="bg-slate-50 border-b border-slate-100 text-left text-slate-400">
                      <tr className="text-[10px] font-black uppercase tracking-widest text-left">
                        <th className="px-6 py-4">Datum</th>
                        <th className="px-6 py-4">Tijd</th>
                        <th className="px-6 py-4">Baan</th>
                        <th className="px-6 py-4">Extra</th>
                        <th className="px-6 py-4 text-right">Beheer</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50 text-sm">
                      {upcomingReservations.map(r => (
                        <tr key={r.id} className="hover:bg-slate-50/50 transition-colors group">
                          <td className="px-6 py-4 font-bold text-[#091E6D] capitalize">{formatFullLongDate(r.date)}</td>
                          <td className="px-6 py-4 font-bold text-slate-600">{r.startTime} - {getEndTimeStr(r.startTime, r.duration)}</td>
                          <td className="px-6 py-4">
                            <span className="font-black uppercase text-[10px] tracking-widest text-white bg-[#091E6D] rounded-full px-3 py-1">{r.court}</span>
                          </td>
                          <td className="px-6 py-4">
                            {r.useBallMachine ? (
                              <div className="flex items-center gap-2">
                                 <span className="text-[#F77C1A] text-xs font-bold flex items-center gap-1"><Cpu size={14}/> Ballenmachine</span>
                                 {r.paymentStatus === 'pending' && <button type="button" onClick={() => handlePayPending(r)} className="bg-[#091E6D] text-white px-2 py-1 rounded text-[8px] font-black tracking-widest hover:bg-[#F77C1A] transition-all">BETAAL NU</button>}
                                 {r.paymentStatus === 'paid' && <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-[10px] font-bold border border-green-200">Code: {appSettings.lockCode || 'N/A'}</span>}
                              </div>
                            ) : <span className="text-slate-300 text-xs italic">-</span>}
                          </td>
                          <td className="px-6 py-4 text-right">
                            <button type="button" onClick={() => setReservationToDelete(r)} className="text-red-400 hover:text-red-600 hover:bg-red-500/10 p-2 rounded-xl transition-all"><Trash2 size={18}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="space-y-10 animate-in fade-in duration-300">
                {sortedGroupKeys.map((groupName) => (
                  <div key={groupName}>
                    <h3 className="text-sm font-black italic tracking-widest uppercase text-slate-400 mb-4 border-b border-slate-200 pb-2">{groupName}</h3>
                    <div className="grid gap-4 sm:grid-cols-2 text-left">
                      {groupedMyReservations[groupName].map((r) => (
                        <div key={r.id} className="bg-white p-6 rounded-[32px] border border-slate-100 shadow-sm flex justify-between items-center group text-left text-slate-800">
                          <div className="text-left text-slate-800">
                            <p className="text-lg sm:text-xl font-black italic tracking-tighter text-[#F77C1A] uppercase leading-tight">{formatFullLongDate(r.date)}</p>
                            <p className="text-lg sm:text-xl font-black italic tracking-tighter text-[#091E6D] uppercase leading-tight">{r.court} • {r.startTime} - {getEndTimeStr(r.startTime, r.duration)}</p>
                            {r.useBallMachine && (
                              <p className="text-xs text-slate-400 font-bold uppercase flex flex-wrap items-center gap-2 mt-2">
                                <span className="text-[#F77C1A] flex items-center gap-1">
                                  + Ballenmachine
                                  {r.paymentStatus === 'pending' && (
                                     <>
                                       <span className="bg-amber-100 text-amber-600 px-2 py-0.5 rounded text-[8px] ml-1">Wacht op betaling</span>
                                       <button type="button" onClick={() => handlePayPending(r)} className="bg-[#091E6D] text-white px-2 py-0.5 rounded text-[8px] font-black tracking-widest hover:bg-[#F77C1A] transition-all ml-1">BETAAL NU</button>
                                     </>
                                  )}
                                  {r.paymentStatus === 'paid' && (
                                     <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-[10px] ml-1 border border-green-200">
                                       Slot Code: {appSettings.lockCode || 'N/A'}
                                     </span>
                                  )}
                                </span>
                              </p>
                            )}
                          </div>
                          <button type="button" onClick={() => setReservationToDelete(r)} className="text-red-400 bg-red-500/10 hover:bg-red-500/20 p-3 rounded-2xl transition-all ml-2"><Trash2 size={20}/></button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* --- ARCHIEF WEERGAVE --- */}
        {view === 'archive' && (
          <div className="space-y-6 animate-in slide-in-from-bottom-4 text-left text-slate-800">
             <div className="flex items-center gap-4 mb-6">
                <button type="button" onClick={() => setView('my-bookings')} className="p-3 bg-white rounded-2xl shadow-sm text-slate-400 hover:text-[#091E6D] transition-all border border-slate-100">
                  <ChevronLeft size={20} />
                </button>
                <div className="flex items-center gap-3">
                  <Archive className="text-[#091E6D]" size={28} />
                  <h2 className="text-3xl font-black italic tracking-tighter uppercase text-[#091E6D]">Archief</h2>
                </div>
             </div>

             <div className="flex flex-col md:flex-row gap-6">
                <div className="md:w-1/4">
                   <div className="bg-white rounded-[32px] p-6 shadow-sm border border-slate-100 sticky top-24">
                      <h3 className="text-xs font-black uppercase text-slate-400 mb-4 tracking-widest">Maanden</h3>
                      <div className="space-y-2 max-h-[30vh] md:max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
                         {archiveGroupKeys.map(key => (
                           <button type="button" key={key} onClick={() => {
                             const el = document.getElementById(`archive-${key}`);
                             if(el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
                           }} className="block w-full text-left px-4 py-3 text-sm font-bold text-slate-600 hover:bg-slate-50 hover:text-[#091E6D] rounded-xl transition-all">
                             {key}
                           </button>
                         ))}
                         {archiveGroupKeys.length === 0 && <p className="text-xs text-slate-400 italic">Geen oudere boekingen</p>}
                      </div>
                   </div>
                </div>

                <div className="md:w-3/4 space-y-10">
                   {archiveGroupKeys.length === 0 ? (
                      <div className="py-20 text-center bg-white rounded-[40px] border-2 border-dashed border-slate-200 text-slate-800">
                        <Archive className="mx-auto text-slate-300 mb-4" size={48} />
                        <p className="text-slate-400 font-black uppercase text-xs tracking-widest">Je hebt nog geen boekingen in het verleden.</p>
                      </div>
                   ) : (
                      archiveGroupKeys.map(groupName => (
                        <div key={groupName} id={`archive-${groupName}`} className="scroll-mt-32">
                          <h3 className="text-sm font-black italic tracking-widest uppercase text-slate-400 mb-4 border-b border-slate-200 pb-2">{groupName}</h3>
                          <div className="grid gap-4 sm:grid-cols-2">
                             {archiveGrouped[groupName].map(r => (
                                <div key={r.id} className="bg-white p-6 rounded-[32px] border border-slate-100 shadow-sm flex flex-col justify-center opacity-75 hover:opacity-100 transition-opacity">
                                   <p className="text-lg font-black italic tracking-tighter text-slate-500 uppercase leading-tight">{formatFullLongDate(r.date)}</p>
                                   <p className="text-lg font-black italic tracking-tighter text-slate-700 uppercase leading-tight">{r.court} • {r.startTime}</p>
                                   {r.useBallMachine && (
                                     <p className="text-xs text-slate-400 font-bold uppercase mt-2 flex items-center gap-1 bg-slate-50 self-start px-2 py-1 rounded-md">
                                       <Cpu size={12}/> Ballenmachine gebruikt
                                     </p>
                                   )}
                                </div>
                             ))}
                          </div>
                        </div>
                      ))
                   )}
                </div>
             </div>
          </div>
        )}

        {view === 'admin-users' && appUser.role === 'admin' && (
          <div className="space-y-8 animate-in slide-in-from-bottom-6 text-center text-slate-800 text-left">
            <div className="flex items-center justify-between px-2 text-slate-800">
              <h2 className="text-3xl font-black italic tracking-tighter uppercase text-[#091E6D]">BEHEER</h2>
              <div className="flex bg-slate-100 p-1 rounded-2xl text-slate-800">
                <button type="button" onClick={() => { setAdminTab('users'); setAdminSearchTerm(''); }} className={`px-4 py-2 rounded-xl text-[10px] font-black ${adminTab === 'users' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>LEDEN</button>
                <button type="button" onClick={() => { setAdminTab('whitelist'); setAdminSearchTerm(''); }} className={`px-4 py-2 rounded-xl text-[10px] font-black ${adminTab === 'whitelist' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>LIJST</button>
                <button type="button" onClick={() => { setAdminTab('import'); setAdminSearchTerm(''); }} className={`px-4 py-2 rounded-xl text-[10px] font-black ${adminTab === 'import' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>IMPORT</button>
                <button type="button" onClick={() => { setAdminTab('settings'); setAdminSearchTerm(''); }} className={`px-4 py-2 rounded-xl text-[10px] font-black ${adminTab === 'settings' ? 'bg-white text-[#091E6D] shadow-sm' : 'text-slate-500'}`}>INSTELLINGEN</button>
              </div>
            </div>
            
            {adminTab === 'users' && (
              <div className="space-y-4">
                <div className="flex justify-end">
                  <div className="relative w-full sm:w-80">
                    <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                    <input 
                      type="text" 
                      placeholder="Zoek lid op naam of e-mail..." 
                      value={adminSearchTerm}
                      onChange={(e) => setAdminSearchTerm(e.target.value)}
                      className="w-full pl-11 pr-4 py-3 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A] transition-all"
                    />
                  </div>
                </div>
                <div className="bg-white rounded-[40px] border border-slate-100 shadow-xl overflow-hidden text-left text-slate-800 flex flex-col max-h-[75vh]">
                  <div className="overflow-y-auto flex-1 w-full">
                    <table className="w-full text-slate-800 text-left relative">
                      <thead className="bg-slate-50 border-b border-slate-100 text-left text-slate-400 sticky top-0 z-10 shadow-sm">
                        <tr className="text-[10px] font-black uppercase text-slate-400 tracking-widest text-left">
                          <th className="px-6 py-5 text-slate-400 text-left">Naam</th>
                          <th className="px-6 py-5 text-center text-slate-400">Rol</th>
                          <th className="px-6 py-5 text-center text-slate-400">Status</th>
                          <th className="px-6 py-5 text-right text-slate-400">Beheer</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-50 text-slate-800 text-left">
                        {allUsers.filter(u => u.email !== appUser.email && (
                            (u.fullName || '').toLowerCase().includes(adminSearchTerm.toLowerCase()) || 
                            (u.email || '').toLowerCase().includes(adminSearchTerm.toLowerCase())
                        )).map((u) => (
                          <tr key={u.id}>
                            <td className="px-6 py-5 text-left group">
                              <button type="button" onClick={() => { setSelectedUserProfile(u); setView('user-profile'); }} className="text-left w-full h-full outline-none focus:ring-0 cursor-pointer text-[#091E6D] hover:underline transition-all">
                                <p className="font-black text-inherit">{u.fullName}</p>
                                <p className="text-xs text-slate-400 font-medium no-underline">{u.email}</p>
                              </button>
                            </td>
                            <td className="px-6 py-5 text-center">
                              <select
                                value={u.role || 'member'}
                                onChange={(e) => updateUserRole(u.id, e.target.value)}
                                className="bg-slate-50 border-2 border-slate-100 text-[#091E6D] text-[10px] font-black uppercase rounded-xl px-3 py-2 outline-none cursor-pointer focus:border-[#F77C1A] transition-all"
                              >
                                <option value="member">Lid</option>
                                <option value="vcl">VCL</option>
                                <option value="admin">Beheerder</option>
                              </select>
                            </td>
                            <td className="px-6 py-5 text-center">{u.isApproved ? <span className="bg-[#091E6D]/10 text-[#091E6D] text-[10px] px-3 py-1.5 rounded-full font-black uppercase tracking-tighter">Actief</span> : <span className="bg-amber-100 text-amber-700 text-[10px] px-3 py-1.5 rounded-full font-black uppercase animate-pulse">Wachtend</span>}</td>
                            <td className="px-6 py-5 text-right text-slate-800"><div className="flex justify-end gap-2 text-right">{!u.isApproved && <button type="button" onClick={() => approveUser(u.id)} className="bg-[#F77C1A] text-white text-[10px] font-black px-5 py-2.5 rounded-xl shadow-lg">Goedkeuren</button>}<button type="button" onClick={() => setUserToDelete(u)} className="text-red-400 hover:text-red-500 hover:bg-red-500/10 p-2 rounded-lg transition-all"><Trash2 size={18} /></button></div></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {adminTab === 'whitelist' && (
              <div className="bg-white p-8 rounded-[40px] shadow-xl border border-slate-100 text-left text-slate-800">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4 text-slate-800 text-left">
                   <h3 className="text-xl font-black italic uppercase text-[#091E6D]">Officiële Ledenlijst</h3>
                   
                   <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                     <div className="relative w-full sm:w-64">
                       <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                       <input 
                         type="text" 
                         placeholder="Zoeken..." 
                         value={adminSearchTerm}
                         onChange={(e) => setAdminSearchTerm(e.target.value)}
                         className="w-full pl-9 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A] transition-all"
                       />
                     </div>
                     <form onSubmit={(e) => handleAddToWhitelist(e)} className="flex gap-2 text-slate-800 text-left w-full sm:w-auto">
                       <input type="email" required value={whitelistEmail} onChange={e => setWhitelistEmail(e.target.value)} placeholder="Email lid" className="w-full sm:w-48 bg-slate-50 border-2 border-slate-100 px-4 py-2 rounded-xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A]" />
                       <button type="submit" disabled={submitting} className="bg-[#F77C1A] hover:bg-[#e06b12] text-white p-2 rounded-xl transition-all flex-shrink-0">
                         {submitting ? <Loader2 className="animate-spin text-white" size={20}/> : <Plus size={20}/>}
                       </button>
                     </form>
                   </div>
                </div>
                <div className="max-h-[400px] overflow-y-auto space-y-2 text-slate-800 text-left custom-scrollbar">
                   {whitelist.filter((item) => (item.email || '').toLowerCase().includes(adminSearchTerm.toLowerCase())).map((item) => (
                     <div key={item.id} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 text-slate-800 text-left">
                       <span className="text-sm font-bold text-[#091E6D]">{item.email}</span>
                       <button type="button" onClick={() => setWhitelistItemToDelete(item)} className="text-red-400 p-2 hover:text-red-500 hover:bg-red-500/10 rounded-lg transition-all"><Trash2 size={16}/></button>
                     </div>
                   ))}
                </div>
              </div>
            )}

            {adminTab === 'import' && (
              <div className="bg-white p-10 rounded-[40px] shadow-xl max-w-2xl mx-auto text-center text-slate-800 text-center">
                 <Upload className="text-[#F77C1A] mx-auto mb-4" size={48} />
                 <h3 className="text-2xl font-black italic uppercase mb-6 text-[#091E6D] text-center">Bulk Import</h3>
                 <textarea className="w-full h-40 bg-slate-50 border-2 border-slate-100 rounded-[32px] p-6 font-bold text-sm text-slate-800 outline-none mb-4 focus:border-[#F77C1A]" value={importText} onChange={e => setImportText(e.target.value)} placeholder="jan@mail.nl, piet@mail.nl" />
                 <button type="button" onClick={handleBulkImport} disabled={submitting} className="w-full py-5 bg-[#F77C1A] hover:bg-[#e06b12] text-white rounded-2xl font-black uppercase text-xs flex items-center justify-center gap-2 transition-all">
                   {submitting ? <Loader2 className="animate-spin text-white" size={18}/> : 'Lijst Importeren'}
                 </button>
              </div>
            )}

            {adminTab === 'settings' && (
              <div className="bg-white p-8 rounded-[40px] shadow-xl border border-slate-100 text-left text-slate-800">
                <div className="flex items-center gap-3 mb-6 text-[#091E6D]">
                   <Settings size={28} />
                   <h3 className="text-xl font-black italic uppercase">Instellingen</h3>
                </div>
                <form onSubmit={handleSaveSettings} className="space-y-6">
                  <div>
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Mollie API Key (Live of Test)</label>
                    <input name="mollieApiKey" defaultValue={appSettings.mollieApiKey ? 'xxxxxxxxxxxxxxxxxxxxxxxx' : ''} type="text" placeholder="Bijv: test_ of live_" className="w-full bg-slate-50 border-2 border-slate-100 px-5 py-4 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A]" />
                    <p className="text-xs text-slate-400 mt-2 font-medium">De API sleutel wordt veilig verborgen als kruisjes. Vul een nieuwe in om deze te wijzigen.</p>
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Mollie Betaallink (Plink URL - Backup/Verouderd)</label>
                    <input name="paymentLink" defaultValue={appSettings.paymentLink || ''} type="url" placeholder="https://useplink.com/..." className="w-full bg-slate-50 border-2 border-slate-100 px-5 py-4 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A]" />
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Code Cijferslot Ballenmachine (3 cijfers)</label>
                    <input name="lockCode" defaultValue={appSettings.lockCode || ''} type="text" pattern="\d{3}" maxLength={3} minLength={3} placeholder="Bijv. 123" className="w-full bg-slate-50 border-2 border-slate-100 px-5 py-4 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A]" required />
                    <p className="text-xs text-slate-400 mt-2 font-medium">Huidige code: <span className="font-black text-[#091E6D]">{appSettings.lockCode || 'Nog niet ingesteld'}</span>. Deze code wordt getoond na betaling.</p>
                  </div>
                  <button type="submit" disabled={submitting} className="w-full sm:w-auto py-4 px-8 bg-[#F77C1A] hover:bg-[#e06b12] text-white rounded-2xl font-black uppercase text-xs transition-all flex items-center justify-center gap-2 shadow-lg shadow-[#F77C1A]/30">
                    {submitting ? <Loader2 className="animate-spin text-white" size={18}/> : 'Instellingen Opslaan'}
                  </button>
                </form>
              </div>
            )}
          </div>
        )}

        {view === 'user-profile' && selectedUserProfile && (
          <div className="space-y-6 animate-in slide-in-from-bottom-4 text-left text-slate-800">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4 text-slate-800 text-left">
              <div className="flex items-center gap-4">
                <button type="button" onClick={() => { setView('admin-users'); setSelectedUserProfile(null); }} className="p-3 bg-white rounded-2xl shadow-sm text-slate-400 hover:text-[#091E6D] transition-all border border-slate-100">
                  <ChevronLeft size={20} />
                </button>
                <div>
                  <h2 className="text-3xl font-black italic tracking-tighter uppercase text-[#091E6D] leading-none">{selectedUserProfile.fullName}</h2>
                  <div className="flex items-center gap-2 mt-1">
                     <p className="text-xs font-bold text-slate-400">{selectedUserProfile.email}</p>
                     <span className="bg-[#091E6D]/10 text-[#091E6D] text-[8px] px-2 py-0.5 rounded-md font-black uppercase tracking-wider">
                       {selectedUserProfile.role === 'admin' ? 'Beheerder' : selectedUserProfile.role === 'vcl' ? 'VCL' : 'Lid'}
                     </span>
                  </div>
                </div>
              </div>
            </div>

            {profileReservations.length === 0 ? (
              <div className="col-span-full py-20 text-center bg-white rounded-[40px] border-2 border-dashed border-slate-200 text-slate-800 text-center">
                <Clock className="mx-auto text-slate-300 mb-4" size={48} />
                <p className="text-slate-400 font-black uppercase text-xs tracking-widest">Dit lid heeft nog geen boekingen in het systeem.</p>
              </div>
            ) : (
              <div className="bg-white rounded-[32px] border border-slate-100 shadow-sm overflow-hidden text-left text-slate-800 animate-in fade-in duration-300">
                <div className="overflow-x-auto">
                  <table className="w-full text-slate-800 text-left whitespace-nowrap">
                    <thead className="bg-slate-50 border-b border-slate-100 text-left text-slate-400">
                      <tr className="text-[10px] font-black uppercase tracking-widest text-left">
                        <th className="px-6 py-4">Datum</th>
                        <th className="px-6 py-4">Tijd</th>
                        <th className="px-6 py-4">Baan</th>
                        <th className="px-6 py-4">Extra</th>
                        <th className="px-6 py-4 text-right">Beheer</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50 text-sm">
                      {profileReservations.map(r => (
                        <tr key={r.id} className="hover:bg-slate-50/50 transition-colors group">
                          <td className="px-6 py-4 font-bold text-[#091E6D] capitalize">{formatFullLongDate(r.date)}</td>
                          <td className="px-6 py-4 font-bold text-slate-600">{r.startTime} - {getEndTimeStr(r.startTime, r.duration)}</td>
                          <td className="px-6 py-4">
                            <span className="font-black uppercase text-[10px] tracking-widest text-white bg-[#091E6D] rounded-full px-3 py-1">{r.court}</span>
                          </td>
                          <td className="px-6 py-4">
                            {r.useBallMachine ? (
                              <div className="flex items-center gap-2">
                                 <span className="text-[#F77C1A] text-xs font-bold flex items-center gap-1"><Cpu size={14}/> Ballenmachine</span>
                                 {r.paymentStatus === 'paid' && <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-[10px] font-bold border border-green-200">Betaald</span>}
                                 {r.paymentStatus === 'pending' && <span className="bg-amber-100 text-amber-600 px-2 py-0.5 rounded text-[10px] font-bold border border-amber-200">Openstaand</span>}
                              </div>
                            ) : <span className="text-slate-300 text-xs italic">-</span>}
                          </td>
                          <td className="px-6 py-4 text-right">
                            <button type="button" onClick={() => setReservationToDelete(r)} className="text-red-400 hover:text-red-600 hover:bg-red-500/10 p-2 rounded-xl transition-all" title="Boeking annuleren"><Trash2 size={18}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </main>

      {/* Modal voor reservering met sluit-kruisje */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-50 flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[48px] w-full max-w-lg shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800">
              <div className={`p-8 text-white text-center rounded-t-[48px] relative bg-[#091E6D]`}>
                 <button type="button" onClick={() => setIsModalOpen(false)} className="absolute top-6 right-6 p-2 bg-white/20 hover:bg-white/40 rounded-full transition-all text-white">
                   <X size={20} />
                 </button>
                 <h3 className="text-2xl font-black italic tracking-tighter uppercase text-white text-center">{['admin', 'vcl'].includes(appUser.role) ? 'Vereniging Boeking' : 'Baan Reserveren'}</h3>
              </div>
              <form onSubmit={handleBooking} className="p-8 space-y-6 text-slate-800 text-left">
                 <div className="text-left text-slate-800">
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 text-left">1. Selecteer Baan</label>
                    <div className="grid grid-cols-3 gap-3 text-slate-800">
                       {BANEN.map(b => {
                         const dur = ['admin', 'vcl'].includes(appUser.role) ? calculateDuration(formData.startTime, formData.endTime) : parseInt(formData.duration || '60', 10);
                         const isBusy = (formData.dates || []).filter(d => d && d !== '').some((date) => checkOverlap(formData.startTime, dur, date, b, reservations));
                         
                         const courts = formData.courts || [];
                         return (
                           <button 
                            key={b} 
                            type="button" 
                            disabled={isBusy}
                            onClick={() => toggleCourtSelection(b)} 
                            className={`py-4 rounded-3xl text-xs font-black border-2 transition-all flex flex-col items-center justify-center gap-1 ${
                              isBusy 
                                ? 'bg-slate-100 border-slate-100 text-slate-300 cursor-not-allowed' 
                                : courts.includes(b) 
                                  ? 'bg-[#091E6D] border-[#091E6D] text-white shadow-lg' 
                                  : 'bg-slate-50 border-slate-100 text-[#091E6D]'
                            }`}>
                              <span>{b}</span>
                              {isBusy && <span className="text-[8px] uppercase opacity-60">Bezet</span>}
                           </button>
                         );
                       })}
                    </div>
                 </div>
                 {['admin', 'vcl'].includes(appUser.role) && (
                   <div className="space-y-2 text-left text-slate-800">
                     <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 text-left">2. Beschrijving Activiteit</label>
                     <input className="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-[24px] font-bold text-slate-800 outline-none focus:border-[#F77C1A] text-sm text-left" placeholder="Bijv: Competitie, Training..." value={formData.description || ''} onChange={e => setFormData((prev) => ({...prev, description: e.target.value}))} />
                   </div>
                 )}
                 <div className="space-y-3 text-left text-slate-800">
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest text-center">Datum</label>
                    {['admin', 'vcl'].includes(appUser.role) ? (formData.dates || []).map((d, idx) => (
                      <div key={idx} className="space-y-2 mb-4 animate-in slide-in-from-left-2 text-slate-800 text-left">
                        <div className="bg-[#091E6D]/5 border border-[#091E6D]/20 p-3 rounded-2xl text-center"><p className="text-[11px] font-black text-[#091E6D] uppercase">{d ? `Geselecteerd: ${formatDateToNL(d)}` : 'Kies een datum'}</p></div>
                        <div className="flex gap-2 text-slate-800 text-left">
                          <input type="date" className="flex-1 bg-slate-50 border border-slate-100 rounded-2xl px-4 py-3 font-bold text-sm text-slate-800 w-full text-left outline-none focus:border-[#F77C1A]" value={d || ''} onChange={e => updateDateRow(idx, e.target.value)} />
                          {idx > 0 && <button type="button" onClick={() => setFormData((prev) => ({ ...prev, dates: (prev.dates || []).filter((_, i) => i !== idx) }))} className="bg-red-50 text-red-500 p-3 rounded-2xl transition-all hover:bg-red-100"><X size={18}/></button>}
                        </div>
                      </div>
                    )) : <div className="p-3 bg-slate-50 rounded-2xl font-black text-center text-[#091E6D] border border-slate-100">{getDayOnly((formData.dates || [])[0] || selectedDateStr)}</div>}
                 </div>
                 
                 <div className="bg-[#091E6D]/5 p-5 rounded-[32px] border border-[#091E6D]/10 flex items-center justify-between text-slate-800">
                    <div className="flex items-center gap-3 text-left">
                       <div className={`p-3 rounded-2xl transition-all ${formData.useBallMachine ? 'bg-[#F77C1A] text-white' : 'bg-white text-[#F77C1A] shadow-sm'}`}><Cpu size={20} /></div>
                       <p className="text-[13px] font-black text-[#091E6D] uppercase tracking-tight leading-none">Ballenmachine huren {appUser.role !== 'admin' && '€6,99'}</p>
                    </div>
                    <button type="button" onClick={() => setFormData((prev) => ({...prev, useBallMachine: !formData.useBallMachine}))} className={`w-12 h-6 rounded-full relative transition-all ${formData.useBallMachine ? 'bg-[#F77C1A]' : 'bg-slate-200'}`}><div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${formData.useBallMachine ? 'left-7' : 'left-1'}`}></div></button>
                 </div>

                 <div className="grid grid-cols-2 gap-4 text-slate-800 text-left">
                    <div className="text-left text-slate-800">
                       <label className="block text-[10px] font-black text-slate-400 uppercase mb-1 tracking-widest text-left">Starttijd</label>
                       <select className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-3xl font-black text-[#091E6D] text-sm outline-none focus:border-[#F77C1A] text-left" value={formData.startTime || ''} onChange={e => setFormData((prev) => ({ ...prev, startTime: e.target.value }))}>
                         {timeSlots.map(t => <option key={t} value={t}>{t} uur</option>)}
                       </select>
                    </div>
                    <div className="text-left text-slate-800">
                       <label className="block text-[10px] font-black text-slate-400 uppercase mb-1 tracking-widest text-left">{['admin', 'vcl'].includes(appUser.role) ? 'Eindtijd' : 'Duur'}</label>
                       {['admin', 'vcl'].includes(appUser.role) ? (
                         <select className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-3xl font-black text-[#091E6D] text-sm outline-none focus:border-[#F77C1A] text-left" value={formData.endTime || ''} onChange={e => setFormData((prev) => ({ ...prev, endTime: e.target.value }))}>
                           {timeSlots.map(t => <option key={t} value={t}>{t} uur</option>)}
                         </select>
                       ) : (
                         <select className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-3xl font-black text-[#091E6D] text-sm outline-none focus:border-[#F77C1A] text-left" value={formData.duration || '60'} onChange={e => setFormData((prev) => ({ ...prev, duration: e.target.value }))}>
                           <option value="30">30 min.</option>
                           <option value="60">60 min.</option>
                           <option value="90">90 min.</option>
                         </select>
                       )}
                    </div>
                 </div>
                 <button type="submit" disabled={submitting || (formData.courts || []).length === 0} className={`w-full py-4 rounded-3xl font-black uppercase text-xs shadow-xl bg-[#F77C1A] hover:bg-[#e06b12] text-white flex items-center justify-center gap-2 transition-all`}>
                   {submitting ? <Loader2 className="animate-spin text-white" size={18} /> : 'Bevestigen'}
                 </button>
                 <button type="button" onClick={() => setIsModalOpen(false)} className="w-full text-slate-400 text-[10px] font-black uppercase mt-2 tracking-widest hover:text-[#091E6D] transition-all text-center">ANNULEREN</button>
              </form>
           </div>
        </div>
      )}

      {/* Modal voor Conflicten / Bezet */}
      {conflictModal.isOpen && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[80] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 p-8 text-center border border-slate-100">
              <div className="w-16 h-16 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                 <AlertCircle size={32} />
              </div>
              <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D] mb-2">Let op</h3>
              <p className="text-sm font-bold text-slate-500 mb-4">
                 Er is een melding over de reservering:
              </p>
              <ul className="text-sm text-[#F77C1A] font-black mb-8 space-y-2">
                {conflictModal.conflicts.map((c, i) => <li key={i}>{c}</li>)}
              </ul>
              <button type="button" onClick={() => setConflictModal({ isOpen: false, conflicts: [] })} className="w-full py-4 bg-slate-50 hover:bg-slate-100 text-slate-600 rounded-2xl font-black uppercase text-xs transition-all border border-slate-200">Begrepen</button>
           </div>
        </div>
      )}

      {/* Modal voor reservering annuleren (Bevestiging) */}
      {reservationToDelete && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[60] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 p-8 text-center border border-slate-100">
              <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                 <AlertCircle size={32} />
              </div>
              <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D] mb-2">Boeking Annuleren</h3>
              <p className="text-sm font-bold text-slate-500 mb-8">
                 Weet je zeker dat je de reservering voor <span className="text-[#F77C1A]">{reservationToDelete.court}</span> op {formatDayMonth(reservationToDelete.date)} van {reservationToDelete.startTime} tot {getEndTimeStr(reservationToDelete.startTime, reservationToDelete.duration)} wilt annuleren?
              </p>
              <div className="flex gap-3">
                 <button type="button" onClick={() => setReservationToDelete(null)} className="flex-1 py-4 bg-slate-50 hover:bg-slate-100 text-slate-600 rounded-2xl font-black uppercase text-xs transition-all border border-slate-200">Terug</button>
                 <button type="button" onClick={confirmDeleteReservation} className="flex-1 py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-black uppercase text-xs transition-all shadow-lg shadow-red-500/30">Annuleren</button>
              </div>
           </div>
        </div>
      )}

      {/* Modal voor lid verwijderen (Bevestiging) */}
      {userToDelete && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[60] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 p-8 text-center border border-slate-100">
              <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                 <AlertCircle size={32} />
              </div>
              <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D] mb-2">Lid Verwijderen</h3>
              <p className="text-sm font-bold text-slate-500 mb-8">
                 Weet je zeker dat je <span className="text-[#F77C1A]">{userToDelete.fullName}</span> wilt verwijderen? Dit kan niet ongedaan worden gemaakt.
              </p>
              <div className="flex gap-3">
                 <button type="button" onClick={() => setUserToDelete(null)} className="flex-1 py-4 bg-slate-50 hover:bg-slate-100 text-slate-600 rounded-2xl font-black uppercase text-xs transition-all border border-slate-200">Annuleren</button>
                 <button type="button" onClick={confirmDeleteUser} className="flex-1 py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-black uppercase text-xs transition-all shadow-lg shadow-red-500/30">Verwijderen</button>
              </div>
           </div>
        </div>
      )}

      {/* Modal voor whitelist item verwijderen (Bevestiging) */}
      {whitelistItemToDelete && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[60] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 p-8 text-center border border-slate-100">
              <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                 <AlertCircle size={32} />
              </div>
              <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D] mb-2">E-mail Verwijderen</h3>
              <p className="text-sm font-bold text-slate-500 mb-8">
                 Weet je zeker dat je <span className="text-[#F77C1A]">{whitelistItemToDelete.email}</span> van de ledenlijst wilt verwijderen?
              </p>
              <div className="flex gap-3">
                 <button type="button" onClick={() => setWhitelistItemToDelete(null)} className="flex-1 py-4 bg-slate-50 hover:bg-slate-100 text-slate-600 rounded-2xl font-black uppercase text-xs transition-all border border-slate-200">Annuleren</button>
                 <button type="button" onClick={confirmDeleteWhitelistItem} className="flex-1 py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-black uppercase text-xs transition-all shadow-lg shadow-red-500/30">Verwijderen</button>
              </div>
           </div>
        </div>
      )}

      {/* Modal voor Wachtwoord Wijzigen */}
      {isPasswordModalOpen && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[80] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 border border-slate-100">
              <div className="p-6 border-b border-slate-100 flex justify-between items-center">
                 <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D]">Wachtwoord wijzigen</h3>
                 <button type="button" onClick={() => setIsPasswordModalOpen(false)} className="p-2 bg-slate-50 hover:bg-slate-100 rounded-full transition-all text-slate-400">
                   <X size={20} />
                 </button>
              </div>
              <form onSubmit={handlePasswordChange} className="p-6 space-y-4">
                 {passwordStatus.success ? (
                    <div className="bg-green-50 p-6 rounded-2xl text-center border border-green-100">
                       <p className="text-green-600 font-black uppercase text-sm tracking-widest mb-1">Succes!</p>
                       <p className="text-slate-600 text-xs font-bold">Je wachtwoord is succesvol gewijzigd.</p>
                    </div>
                 ) : (
                    <>
                       <div>
                          <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Huidig wachtwoord</label>
                          <input type="password" required value={passwordForm.current} onChange={e => setPasswordForm(prev => ({...prev, current: e.target.value}))} className="w-full bg-slate-50 border-2 border-slate-100 px-4 py-3 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A] transition-all" />
                       </div>
                       <div>
                          <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Nieuw wachtwoord</label>
                          <input type="password" required minLength={6} value={passwordForm.new} onChange={e => setPasswordForm(prev => ({...prev, new: e.target.value}))} className="w-full bg-slate-50 border-2 border-slate-100 px-4 py-3 rounded-2xl font-bold text-sm text-slate-800 outline-none focus:border-[#F77C1A] transition-all" />
                       </div>
                       {passwordStatus.error && <div className="p-3 bg-red-50 text-red-600 text-xs font-bold rounded-xl text-center">{passwordStatus.error}</div>}
                       <button type="submit" disabled={passwordStatus.loading} className="w-full py-4 bg-[#F77C1A] hover:bg-[#e06b12] text-white rounded-2xl font-black uppercase text-xs transition-all shadow-lg shadow-[#F77C1A]/30 flex items-center justify-center gap-2 mt-2">
                          {passwordStatus.loading ? <Loader2 className="animate-spin" size={18} /> : 'Wijzigen'}
                       </button>
                    </>
                 )}
              </form>
           </div>
        </div>
      )}

      {/* Modal voor Mollie / Betaling Ballenmachine */}
      {paymentModal.isOpen && (
        <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-md z-[70] flex items-center justify-center p-4 overflow-y-auto text-left text-slate-800">
           <div className="bg-white rounded-[32px] w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden text-slate-800 p-8 text-center border border-slate-100">
              <div className="w-16 h-16 bg-[#091E6D]/10 text-[#091E6D] rounded-full flex items-center justify-center mx-auto mb-4">
                 <Cpu size={32} />
              </div>
              <h3 className="text-xl font-black italic tracking-tighter uppercase text-[#091E6D] mb-2">Huur Ballenmachine</h3>
              
              {paymentModal.isRedirecting ? (
                 <div className="py-8 flex flex-col items-center">
                    <Loader2 className="animate-spin text-[#F77C1A] mb-4" size={40} />
                    <p className="text-sm font-bold text-slate-500">Je wordt doorgestuurd naar Mollie...</p>
                    <p className="text-xs text-slate-400 mt-2">Een moment geduld aub.</p>
                 </div>
              ) : !paymentModal.clicked ? (
                <>
                  <p className="text-sm font-bold text-slate-500 mb-6">
                     Je reservering is geplaatst! Klik op de knop hieronder om de huurkosten te voldoen via Mollie. Na de betaling ontvang je direct de code van het slot.
                  </p>
                  
                  <a href={appSettings.paymentLink || "#"} target="_blank" rel="noreferrer" onClick={(e) => {
                     if (!appSettings.paymentLink) {
                       e.preventDefault();
                       alert("De beheerder heeft nog geen betaallink ingesteld.");
                       return;
                     }
                     setPaymentModal(prev => ({ ...prev, clicked: true }));
                  }} className="block w-full py-4 bg-[#091E6D] hover:bg-[#05113D] text-white rounded-2xl font-black uppercase text-xs transition-all shadow-lg shadow-[#091E6D]/30 mb-3 text-center">
                     Betaal via Mollie (Verouderd)
                  </a>
                </>
              ) : !paymentModal.showCode ? (
                <>
                  <div className="py-8 flex flex-col items-center">
                    <Loader2 className="animate-spin text-[#F77C1A] mb-4" size={40} />
                    <p className="text-sm font-bold text-slate-500">Wachten op betalingsbevestiging...</p>
                    <p className="text-xs font-bold text-slate-400 mt-2">Zodra Mollie de betaling bevestigt, verschijnt de code.</p>
                    <p className="text-xl font-black text-[#091E6D] mt-4">Nog {paymentModal.countdown} sec</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="bg-green-50 p-6 rounded-3xl border border-green-100 mb-4 mt-4">
                    <p className="text-[10px] font-black text-green-600 uppercase tracking-widest mb-1">Succes!</p>
                    <p className="text-sm font-bold text-slate-600 mb-4">De code van het cijferslot van de ballenmachine is:</p>
                    <p className="text-4xl font-black tracking-widest text-[#091E6D]">{appSettings.lockCode || 'Geen code ingesteld'}</p>
                  </div>
                  <p className="text-xs font-bold text-slate-500 mb-6 px-2">
                     Je kunt deze code ook altijd weer terugvinden bij <span className="text-[#091E6D]">Mijn Boekingen</span>.
                  </p>
                  <button type="button" onClick={() => {
                    setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
                    localStorage.removeItem('pendingMolliePayment');
                  }} className="w-full py-4 bg-slate-50 hover:bg-slate-100 text-slate-600 rounded-2xl font-black uppercase text-xs transition-all border border-slate-200">Sluiten & Spelen</button>
                </>
              )}

              {!paymentModal.showCode && !paymentModal.isRedirecting && (
                <button type="button" onClick={() => {
                  setPaymentModal({ isOpen: false, reservationId: '', clicked: false, countdown: 30, showCode: false, isRedirecting: false });
                  localStorage.removeItem('pendingMolliePayment');
                }} className="w-full mt-2 py-3 text-slate-400 hover:text-slate-600 font-black uppercase text-[10px] transition-all">Sluiten (Later Betalen)</button>
              )}
           </div>
        </div>
      )}

      <footer className="text-center py-12 px-6 text-[10px] font-black text-slate-300 uppercase tracking-[0.4em]">Aduarder Tennis Club • ATC</footer>
    </div>
  );
};

export default App;
